import axiosClient from './axiosClient';

// Exercises
export const getLessonExercises = (lessonId: string) => {
    return axiosClient.get(`/exercises/lesson/${lessonId}`);
};

export const createExercise = (data: { title: string, description?: string, lesson_id?: string }) => {
    return axiosClient.post('/exercises/', data);
};

export const getExerciseDetail = (id: string) => {
    return axiosClient.get(`/exercises/${id}`);
};

export const updateExercise = (id: string, data: any) => {
    return axiosClient.put(`/exercises/${id}`, data);
};

export const deleteExercise = (id: string) => {
    return axiosClient.delete(`/exercises/${id}`);
};

export const generateQuestionWithAI = (id: string, params?: { difficulty?: string; temperature?: number }) => {
    return axiosClient.post(`/exercises/${id}/ai-generate`, null, { params });
};

export const bulkGenerateQuestionsWithAI = (id: string, count: number = 5, params?: { difficulty?: string; temperature?: number }) => {
    return axiosClient.post(`/exercises/${id}/ai-bulk-generate`, null, { params: { count, ...params } });
};

export const convertExamToQuestions = (id: string, examContent: string) => {
    return axiosClient.post(`/exercises/${id}/ai-convert-exam`, { exam_content: examContent });
};

// Questions
export const getExerciseQuestions = (exerciseId: string) => {
    return axiosClient.get(`/exercises/${exerciseId}/questions`);
};

export const addQuestionToExercise = (exerciseId: string, data: any) => {
    return axiosClient.post(`/exercises/${exerciseId}/questions`, data);
};

export const updateQuestion = (questionId: string, data: any) => {
    return axiosClient.put(`/exercises/questions/${questionId}`, data);
};

export const deleteQuestion = (questionId: string) => {
    return axiosClient.delete(`/exercises/questions/${questionId}`);
};

export const reorderExerciseQuestions = (exerciseId: string, questionIds: string[]) => {
    return axiosClient.put(`/exercises/${exerciseId}/reorder-questions`, { question_ids: questionIds });
};

// Assignments
export const getExerciseAssignments = (exerciseId: string) => {
    return axiosClient.get(`/exercises/${exerciseId}/assignments`);
};

export const assignExercise = (exerciseId: string, data: { class_id?: string, student_id?: string, due_date?: string }) => {
    return axiosClient.post(`/exercises/${exerciseId}/assignments`, data);
};

export const revokeAssignment = (exerciseId: string, assignmentId: string) => {
    return axiosClient.delete(`/exercises/${exerciseId}/assignments/${assignmentId}`);
};

export const aiGenerateWorksheet = (lessonId: string, data: { mcq_count: number, essay_count: number, blank_count: number }) => {
    return axiosClient.post(`/exercises/lesson/${lessonId}/ai-worksheet`, data);
};
